__turbopack_context__.v({
  "backgroundLayer": "atoms-module__UwFOIa__backgroundLayer",
  "content": "atoms-module__UwFOIa__content",
  "geistMonoNumbers": "atoms-module__UwFOIa__geistMonoNumbers",
  "lbCardBg": "atoms-module__UwFOIa__lbCardBg",
  "lbCardBlur": "atoms-module__UwFOIa__lbCardBlur",
  "lbMetaLabel": "atoms-module__UwFOIa__lbMetaLabel" + " " + "atoms-module__UwFOIa__monoUppercase",
  "lbRadialStroke": "atoms-module__UwFOIa__lbRadialStroke",
  "lbStrokeCard": "atoms-module__UwFOIa__lbStrokeCard",
  "lbStrokeFrosted": "atoms-module__UwFOIa__lbStrokeFrosted",
  "lbToggleBlur": "atoms-module__UwFOIa__lbToggleBlur",
  "monoUppercase": "atoms-module__UwFOIa__monoUppercase",
  "pageRoot": "atoms-module__UwFOIa__pageRoot",
  "pl-accordion-control": "atoms-module__UwFOIa__pl-accordion-control",
  "sectionWidth": "atoms-module__UwFOIa__sectionWidth",
});
